"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SignalingClientEventType_1 = require("../signalingclient/SignalingClientEventType");

var BaseTask_1 = require("./BaseTask");

var CleanStoppedSessionTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(CleanStoppedSessionTask, _BaseTask_1$default);

  var _super = _createSuper(CleanStoppedSessionTask);

  function CleanStoppedSessionTask(context) {
    var _this;

    _classCallCheck(this, CleanStoppedSessionTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'CleanStoppedSessionTask';
    _this.taskCanceler = null;
    return _this;
  }

  _createClass(CleanStoppedSessionTask, [{
    key: "cancel",
    value: function cancel() {
      if (this.taskCanceler) {
        this.taskCanceler.cancel();
        this.taskCanceler = null;
      }
    }
  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iterator, _step, observer, tile;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!this.context.signalingClient.ready()) {
                  _context.next = 5;
                  break;
                }

                this.context.signalingClient.closeConnection();
                _context.next = 5;
                return this.receiveWebSocketClosedEvent();

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                throw _context.t0;

              case 10:
                _context.prev = 10;
                _iterator = _createForOfIteratorHelper(this.context.removableObservers);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    observer = _step.value;
                    observer.removeObserver();
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                this.context.statsCollector.stop();
                this.context.statsCollector = null;
                this.context.connectionMonitor.stop();
                this.context.connectionMonitor = null;

                if (this.context.peer) {
                  this.context.peer.close();
                }

                this.context.peer = null;
                this.context.localVideoSender = null;
                this.context.sdpAnswer = null;
                this.context.sdpOfferInit = null;
                this.context.indexFrame = null;
                this.context.videoDownlinkBandwidthPolicy.reset();
                this.context.iceCandidateHandler = null;
                this.context.iceCandidates = [];
                this.context.turnCredentials = null;
                this.context.videoSubscriptions = null;
                this.context.transceiverController.reset();

                if (this.context.videoUplinkBandwidthPolicy.setTransceiverController) {
                  this.context.videoUplinkBandwidthPolicy.setTransceiverController(undefined);
                }

                if (this.context.videoDownlinkBandwidthPolicy.bindToTileController) {
                  this.context.videoDownlinkBandwidthPolicy.bindToTileController(undefined);
                }

                tile = this.context.videoTileController.getLocalVideoTile();

                if (tile) {
                  tile.bindVideoStream('', true, null, null, null, null);
                }

                this.context.videoTileController.removeAllVideoTiles();
                return _context.finish(10);

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7, 10, 35]]);
      }));
    }
  }, {
    key: "receiveWebSocketClosedEvent",
    value: function receiveWebSocketClosedEvent() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var Interceptor = /*#__PURE__*/function () {
          function Interceptor(signalingClient) {
            _classCallCheck(this, Interceptor);

            this.signalingClient = signalingClient;
          }

          _createClass(Interceptor, [{
            key: "cancel",
            value: function cancel() {
              this.signalingClient.removeObserver(this);
              reject(new Error("CleanStoppedSessionTask got canceled while waiting for the WebSocket closed event"));
            }
          }, {
            key: "handleSignalingClientEvent",
            value: function handleSignalingClientEvent(event) {
              if (event.type === SignalingClientEventType_1.default.WebSocketClosed) {
                this.signalingClient.removeObserver(this);
                resolve();
              }
            }
          }]);

          return Interceptor;
        }();

        var interceptor = new Interceptor(_this2.context.signalingClient);
        _this2.taskCanceler = interceptor;

        _this2.context.signalingClient.registerObserver(interceptor);
      });
    }
  }]);

  return CleanStoppedSessionTask;
}(BaseTask_1.default);

exports.default = CleanStoppedSessionTask;